import React from 'react';

const PlayersIndex = () => {
  return <h1 className="text-purple-600">404</h1>;
};

export default PlayersIndex;
